import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Cart({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Cart.Outline {...props} /> : <Cart.Solid {...props} />;
}

Cart.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M2.76379 3.3241L4.84379 3.6841L5.80679 15.1571C5.88379 16.0941 6.66679 16.8131 7.60679 16.8101H18.5158C19.4128 16.8121 20.1738 16.1521 20.3008 15.2641L21.2498 8.7061C21.3558 7.9731 20.8468 7.2931 20.1148 7.1871C20.0508 7.1781 5.17779 7.1731 5.17779 7.1731"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.16815 20.2767C7.46915 20.2767 7.71215 20.5207 7.71215 20.8207C7.71215 21.1217 7.46915 21.3657 7.16815 21.3657C6.86715 21.3657 6.62415 21.1217 6.62415 20.8207C6.62415 20.5207 6.86715 20.2767 7.16815 20.2767Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4484 20.2767C18.7494 20.2767 18.9934 20.5207 18.9934 20.8207C18.9934 21.1217 18.7494 21.3657 18.4484 21.3657C18.1474 21.3657 17.9044 21.1217 17.9044 20.8207C17.9044 20.5207 18.1474 20.2767 18.4484 20.2767Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Cart.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.19141 20.5884C6.19141 19.7484 6.87141 19.0684 7.71141 19.0684C8.54141 19.0684 9.22141 19.7484 9.22141 20.5884C9.22141 21.4184 8.54141 22.0984 7.71141 22.0984C6.87141 22.0984 6.19141 21.4184 6.19141 20.5884ZM17.4414 20.5884C17.4414 19.7484 18.1214 19.0684 18.9614 19.0684C19.7914 19.0684 20.4714 19.7484 20.4714 20.5884C20.4714 21.4184 19.7914 22.0984 18.9614 22.0984C18.1214 22.0984 17.4414 21.4184 17.4414 20.5884Z"
          className="icon-secondary"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4715 6.34887C21.0815 6.34887 21.4815 6.55887 21.8815 7.01887C22.2815 7.47887 22.3515 8.13887 22.2615 8.73787L21.3115 15.2979C21.1315 16.5589 20.0515 17.4879 18.7815 17.4879H7.8715C6.5415 17.4879 5.4415 16.4679 5.3315 15.1489L4.4115 4.24787L2.9015 3.98787C2.5015 3.91787 2.2215 3.52787 2.2915 3.12787C2.3615 2.71787 2.7515 2.44787 3.1615 2.50787L5.5465 2.86787C5.8865 2.92887 6.1365 3.20787 6.1665 3.54787L6.3565 5.78787C6.3865 6.10887 6.6465 6.34887 6.9665 6.34887H20.4715ZM14.4115 11.5479H17.1815C17.6015 11.5479 17.9315 11.2079 17.9315 10.7979C17.9315 10.3779 17.6015 10.0479 17.1815 10.0479H14.4115C13.9915 10.0479 13.6615 10.3779 13.6615 10.7979C13.6615 11.2079 13.9915 11.5479 14.4115 11.5479Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
